// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1kQbs","icon":"SortAdornment_icon__1tnjF","up":"SortAdornment_up__308Rq","down":"SortAdornment_down__DMj4o","active":"SortAdornment_active__2kNco"};